import { gql } from '@apollo/client';

export const GET_ENUM = gql`
  query getEnum($enumName: String!) {
    enumValues(name: $enumName) {
      name
    }
  }
`;

export default GET_ENUM;
